import countdown from "../countdown"
import primer from "../primer"

export default (getView) => (nextStepPath, timeoutSeconds) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),
  ...primer(),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initCountdown()
    this.initPrimer({
      checkoutCompletePath: nextStepPath,
    })
  },
})
